import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
export function Layout() {
  return <div className="min-h-screen flex flex-col font-sans bg-cafe-100 text-cafe-900 bg-noise" data-id="element-137">
      <Navbar data-id="element-138" />
      <main className="flex-grow pt-20 relative z-20" data-id="element-139">
        <Outlet data-id="element-140" />
      </main>
      <Footer data-id="element-141" />
    </div>;
}